<template>
  <button
    class="livelo-notification"
    @click="goToStatement"
  >
    <span>
      <i>
        <PrataCoinSVG />
      </i>
      {{ pointsAvailableToTransfer }}P$
    </span>
  </button>
</template>

<script>
import { mapState } from 'vuex';

import PrataCoinSVG from '@/assets/icons/PrataCoin.vue';

export default {
  name: 'LiveloPoints',
  components: {
    PrataCoinSVG,
  },
  computed: {
    ...mapState({
      user: (state) => state.user.userInfo,
    }),
    pointsAvailableToTransfer() {
      return this.user?.rewards?.points_available_to_transfer;
    },
  },
  methods: {
    goToStatement() {
      this.$router.push({ name: 'livelo-statement' });
    },
  },
};
</script>

<style lang="scss" scoped>
.livelo-notification {
  position: relative;
  margin: 0;

  display: flex;
  border: none;
  border-radius: $radius-control;
  padding: 6px 8px 4px;
  min-height: 100%;
  background-color: $color-surface;

  gap: 4px;
  align-items: center;

  cursor: pointer;

  @include focus-ring;

  &:hover {
    $color: #ebbc2e;

    background-color: $color;
    color: darken($color, 30%);

    :deep(svg path) {
      fill: darken($color, 25%);
    }
  }

  span {
    font: {
      size: 14px;
      weight: 600;
    }
    line-height: 20px;
    color: map.get($stone-types, "800");

    i {
      display: inline-flex;
      vertical-align: middle;
    }
  }
}
</style>
